import update from 'immutability-helper'
import _ from 'lodash'
import {
    RELATION_ADDRESS_MODEL_SELECTED,
    RELATION_ADDRESS_MODEL_UPDATED_BY_FORM,
    RELATION_ADDRESS_MODEL_UPDATED_ON_SERVER
} from '../actions/types'


export default function address(state = {
    model: {

    },
    pristine: {

    },
    dirty: false
}, action = {}) {
    switch(action.type) {
        case RELATION_ADDRESS_MODEL_SELECTED:
            return update(state, {
                model: {$set: action.payload},
                pristine: {$set: action.payload},
                dirty: {$set: false}
            })

        case RELATION_ADDRESS_MODEL_UPDATED_BY_FORM:
            const {field, value} = action.payload;
            const updatedModel = update(state.model, {
                [field]: {$set: value}
            });
            if (_.isEqual(updatedModel, state.pristine)) {
                return update(state, {
                    model: {$set: updatedModel},
                    dirty: {$set: false}
                })
            } else {
                return update(state, {
                    model: {$set: updatedModel},
                    dirty: {$set: true}
                })
            }

        case RELATION_ADDRESS_MODEL_UPDATED_ON_SERVER:
            return update(state, {
                pristione: {$set: action.payload},
                dirty: {$set: false}
            })

        default: return state;
    }
}


// WEBPACK FOOTER //
// ./src/stores/address.js